import { LOGIN_MODE } from '../../../../types/enums';
import { NeobetBaseLoginForm } from './LoginForm';

const NeobetHybridLoginForm = () => {
  return <NeobetBaseLoginForm mode={LOGIN_MODE.USERNAME} testId='neobet-hybrid-login-form' />;
};

export default NeobetHybridLoginForm;
